import type { TeamMemberDisplay } from '../../types';
import styles from './TeamDisplay.module.css';

interface Props {
  members: TeamMemberDisplay[];
}

export function TeamDisplay({ members }: Props) {
  if (!members || members.length === 0) {
    return <span className={styles.unassigned}>Unassigned</span>;
  }

  const lead = members.find((m) => m.role === 'owner');
  const sponsor = members.find((m) => m.role === 'sponsor');
  const others = members
    .filter((m) => m.role !== 'owner' && m.role !== 'sponsor')
    .sort((a, b) => a.display_order - b.display_order)
    .map((m) => m.name.split(' ')[0]);

  return (
    <div className={styles.root}>
      {lead && (
        <div>
          <span className={styles.roleLabel}>Lead: </span>
          <span className={styles.ownerName}>{lead.name.split(' ')[0]}</span>
        </div>
      )}
      {sponsor && (
        <div>
          <span className={styles.roleLabel}>Sponsor: </span>
          <span className={styles.memberName}>{sponsor.name.split(' ')[0]}</span>
        </div>
      )}
      {others.length > 0 && (
        <div>
          <span className={styles.roleLabel}>Team: </span>
          <span className={styles.memberName}>{others.join(', ')}</span>
        </div>
      )}
    </div>
  );
}
